import React from "react";
import { Popover, Table, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import { isEmptyVal, isNotEmpty, displayField } from "../../../utils/helpers";

const ActorCell = ({ rowData, ...props }: { rowData: any }) => {
  const { t } = useTranslation();
  const { Cell } = Table;
  const speaker = (
    <Popover title={t("ACTOR") + " " + t("NAME")}>
      <p>
        <b>{t("ACTOR1")} : </b>
        {displayField(rowData.actor1_name)}
      </p>
      {rowData.actor2_name && (
        <p>
          <b>{t("ACTOR2")} : </b>
          {displayField(rowData.actor2_name)}
        </p>
      )}

      {rowData.actor3_name && (
        <p>
          <b>{t("ACTOR3")} : </b>
          {displayField(rowData.actor3_name)}
        </p>
      )}
    </Popover>
  );

  return (
    <Cell {...props}>
      <Whisper
        placement="top"
        speaker={speaker}
        enterable={true}
        preventOverflow={true}
      >
        <a>{displayField(rowData.actor1_name)}</a>
      </Whisper>
    </Cell>
  );
};

export default ActorCell;
